






































































































import {Vue, Component, Prop} from "vue-property-decorator";

@Component
export default class PrivatePolicy extends Vue {
    @Prop({type: String, default: 'body'})
    container: string;
    space: string = '　'; // 全角スペースを表示するためにフィールドとして定義する
}
